__turbopack_context__.v({
  "card": "ItineraryCard-module__fgKQPG__card",
  "legCard": "ItineraryCard-module__fgKQPG__legCard",
});
